<!-- Toast อยู่ข้างนอกสุดของ Router -->
<app-toast-warn *ngIf="toastCustomService.isWarning" [language]="toastCustomService.currentLang"
  (close)="toastCustomService.isWarning = false" [text]="toastCustomService.textWarn"
  [detail]="toastCustomService.detailWarn">
</app-toast-warn>

<app-toast-failed *ngIf="toastCustomService.isError" [language]="toastCustomService.currentLang"
  (close)="toastCustomService.isError = false" [text]="toastCustomService.textError"
  [detail]="toastCustomService.detailError">
</app-toast-failed>

<app-toast-success *ngIf="toastCustomService.isSuccess" [language]="toastCustomService.currentLang"
  (close)="toastCustomService.isSuccess = false" [text]="toastCustomService.textSuccess"
  [detail]="toastCustomService.detailSuccess">
</app-toast-success>
<app-pss-load-begin *ngIf="isLoadingBegin" [timeIn]="2000" (close)="isLoadingBegin = $event">
</app-pss-load-begin>

<!-- app.component.html -->
<div class="bg-gray-50 h-full min-h-full">
  <router-outlet></router-outlet>
</div>



<!-- <div class="min-h-screen bg-gradient-to-br from-indigo-100 to-white flex items-center justify-center">
  <div class="bg-white shadow-xl rounded-2xl p-8 max-w-md w-full text-center space-y-6">
    <h1 class="text-3xl font-bold text-indigo-700">🚀 ยินดีต้อนรับ!</h1>
    <p class="text-gray-600">นี่คือหน้าแรกทดสอบการใช้งาน Tailwind CSS กับ Angular 19</p>

    <button class="bg-indigo-600 hover:bg-indigo-700 text-white font-semibold py-2 px-6 rounded-full transition-all">
      กดฉันสิ 💡
    </button>
  </div>
</div> -->